import {
  LinearProgress,
  linearProgressClasses,
  Stack,
  styled,
  Typography,
} from '@mui/material';

export const UploadProgress = ({ progress }: { progress: string | number }) => {
  const progressVal =
    typeof progress === 'number' ? progress : parseInt(progress);
  return (
    <Stack direction='row' gap={'0.5rem'} alignItems='center'>
      <StyledLinearProgress value={progressVal} variant='determinate' />
      <Typography
        sx={{
          width: '2rem',
          fontSize: '0.75rem',
          fontWeight: 500,
          textAlign: 'right',
        }}
      >{`${progressVal}%`}</Typography>
    </Stack>
  );
};

const StyledLinearProgress = styled(LinearProgress)(({ theme }) => ({
  width: '3.25rem',
  height: '0.125rem',
  marginRight: theme.spacing(2),
  marginLeft: theme.spacing(2),
  alignSelf: 'center',
  borderRadius: theme.borderRadius.primary,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: 'black',
  },
  [`& .${linearProgressClasses.bar}`]: {
    backgroundColor: 'white',
  },
}));
